
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/product-design",
      function () {
        return require("private-next-pages/services/product-design.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/product-design"])
      });
    }
  